module.exports = __webpack_public_path__ + "static/img_oneoff_02@2x-be3b7c1ee9e8ca746e73c744850c33fe.png";